module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrap",
    style: (_vm.$store.getters['skyOverlay/pageWrapStyle'])
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-5ae3fa16"}!./scripts/sky-overlay/page-wrap.html
// module id = 353
// module chunks = 1